import { Router } from "@material-ui/icons";
import { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { api } from "../../config/api";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";
import { pages } from "../../constants/PagePaths";
import { Imp } from "../../models/payment/iamport/IMP";
import {
  ImpCertificationRequestModel,
  ImpCertificationResponseModel,
} from "../../models/payment/iamport/ImpModels";
import GlobalEnvironments from "../../modules/globalEnvironment/GlobalEnvironment";

export default (props: any) => {
  const location = useLocation();
  const linkLocation = location.pathname;
  const strArray = linkLocation.split("/");
  const history = useHistory();

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    const provider = strArray[2];
    const code = params.get("code")!;
    const isExpressCheckout = !!window.opener; // 새 탭에서 열린 경우 Express Checkout
    const redirectUrl = GlobalEnvironments.getAppUrl() + "oauth2/" + provider;
    
    if (!code) {
      if (isExpressCheckout) {
        // Express Checkout 실패시 부모 창에 메시지 전송
        window.opener?.postMessage({
          type: 'SOCIAL_LOGIN_ERROR',
          error: 'No authorization code received'
        }, window.location.origin);
        window.close();
      } else {
        history.replace(pages.login);
        history.push(pages.login);
      }
      return;
    }
    
    new Promise(async () => {
      try {
        const res = await api.socialLogin(provider, code, redirectUrl);
        
        if (isExpressCheckout) {
          // Express Checkout 로그인 성공시 부모 창에 메시지 전송
          if (res.data.uid) {
            // 신규 사용자 - 추가 정보 필요
            window.opener?.postMessage({
              type: 'SOCIAL_LOGIN_PARTIAL',
              userInfo: {
                name: res.data.name || `${provider} 사용자`,
                email: res.data.email,
                phone: res.data.phone,
                provider: provider,
                needsAdditionalInfo: true,
                providerId: res.data.uid
              }
            }, window.location.origin);
          } else {
            // 기존 사용자 - 로그인 완료
            const key = res.data.key;
            const now = new Date();
            util.setCookie({
              cookieName: Cookies.authKey,
              cookieValue: key,
              cookieExpire: new Date(now.setFullYear(now.getFullYear() + 1)),
              cookieDomain: GlobalEnvironments.getDomainUrl(),
              cookiePath: "/",
            });
            
            window.opener?.postMessage({
              type: 'SOCIAL_LOGIN_SUCCESS',
              userInfo: {
                name: res.data.name || `${provider} 사용자`,
                email: res.data.email,
                phone: res.data.phone,
                provider: provider,
                authKey: key
              }
            }, window.location.origin);
          }
          window.close();
        } else {
          // 기존 일반 로그인 로직
          if (res.data.uid) {
            history.replace(pages.login);
            history.push({
              pathname: pages.cert,
              state: {
                provider: provider,
                providerId: res.data.uid,
                email: res.data.email,
              },
            });
          } else {
            const key = res.data.key;
            const now = new Date();
            util.setCookie({
              cookieName: Cookies.authKey,
              cookieValue: key,
              cookieExpire: new Date(now.setFullYear(now.getFullYear() + 1)),
              cookieDomain: GlobalEnvironments.getDomainUrl(),
              cookiePath: "/",
            });
            props.checkUser();

            // 랜딩페이지에 로그인 완료 알림 (일반 로그인 시에도)
            if (window.location.pathname.includes('/oauth2/') && document.referrer.includes('/lending')) {
              try {
                // 부모 페이지에 로그인 완료 메시지 전송
                window.parent.postMessage({
                  type: 'LOGIN_STATUS_CHANGED',
                  isLoggedIn: true,
                  userInfo: {
                    name: res.data.name || `${provider} 사용자`,
                    email: res.data.email,
                    phone: res.data.phone,
                    provider: provider,
                    authKey: key
                  }
                }, window.location.origin);
              } catch (e) {
                console.log('Parent notification failed:', e);
              }
            }

            history.replace(pages.login);
            history.push(pages.index);
          }
        }
      } catch (error) {
        if (isExpressCheckout) {
          window.opener?.postMessage({
            type: 'SOCIAL_LOGIN_ERROR',
            error: 'Login failed'
          }, window.location.origin);
          window.close();
        } else {
          history.replace(pages.login);
          history.push(pages.login);
        }
      }
    });
  }, []);

  return <></>;
};
